import ACTIONS from "./VisitorLogsActionsTypes";

const initialState = {
  postOtpActionLoading: false,
  postOtpActionResponse: null,
  postMediaUploadLoading: false,
  postMediaUploadResponse: null,
  postVisitorLogLoading: false,
  postVistorLogResponse: null,
  getVisitorLogsLoading: false,
  getVisitorLogsResponse: null,
  getSingleVisitorLogsLoading: false,
  getSingleVisitorLogsResponse: null,
  postExcelVisitorLogLoading: false,
  postExcelVisitorLogResponse: null,
  postExcelDataVisitorLogLoading: false,
  postExcelDataVisitorLogResponse: null,
  deleteVisitorLogLoading: false,
  deleteVisitorLogResponse: null,
  putVisitorLogReminderLoading: false,
  putVisitorLogReminderResponse: null,
};

const VisitorLogReducer = (state = initialState, action) => {
  switch (action.type) {
    //
    case ACTIONS.PUT_VISTOR_LOG_REMINDER_REQUEST:
      return {
        ...state,
        putVisitorLogReminderLoading: true,
      };
    case ACTIONS.PUT_VISTOR_LOG_REMINDER_RESPONSE:
      return {
        ...state,
        putVisitorLogReminderLoading: false,
        putVisitorLogReminderResponse: action.payload,
      };
    //
    case ACTIONS.DELETE_VISITOR_LOG_REQUEST:
      return {
        ...state,
        deleteVisitorLogLoading: true,
      };
    case ACTIONS.DELETE_VISITOR_LOG_RESPONSE:
      return {
        ...state,
        deleteVisitorLogLoading: false,
        deleteVisitorLogResponse: action.payload,
      };
    case ACTIONS.DELETE_VISITOR_LOG_RESPONSE_CLEAR:
      return {
        ...state,
        deleteVisitorLogResponse: null,
      };
    //
    case ACTIONS.POST_EXCEL_VISITOR_LOG_REQUEST:
      return {
        ...state,
        postExcelVisitorLogLoading: true,
      };
    case ACTIONS.POST_EXCEL_VISITOR_LOG_RESPONSE:
      return {
        ...state,
        postExcelVisitorLogLoading: false,
        postExcelVisitorLogResponse: action.payload,
      };
    case ACTIONS.POST_EXCEL_VISITOR_LOG_RESPONSE_CLEAR:
      return {
        ...state,
        postExcelVisitorLogResponse: null,
      };
    //
    case ACTIONS.POST_EXCEL_RECORDS_VISITOR_LOG_REQUEST:
      return {
        ...state,
        postExcelDataVisitorLogLoading: true,
      };
    case ACTIONS.POST_EXCEL_RECORDS_VISITOR_LOG_RESPONSE:
      return {
        ...state,
        postExcelDataVisitorLogLoading: false,
        postExcelDataVisitorLogResponse: action.payload,
      };
    case ACTIONS.POST_EXCEL_RECORDS_VISITOR_LOG_RESPONSE_CLEAR:
      return {
        ...state,
        postExcelDataVisitorLogResponse: null,
      };
    //
    case ACTIONS.POST_OTP_ACTION_REQUEST:
      return {
        ...state,
        postOtpActionLoading: true,
      };
    case ACTIONS.POST_OTP_ACTION_RESPONSE:
      return {
        ...state,
        postOtpActionLoading: false,
        postOtpActionResponse: action.payload,
      };
    case ACTIONS.POST_OTP_ACTION_RESPONSE_CLEAR:
      return {
        ...state,
        postOtpActionResponse: null,
      };
    //
    case ACTIONS.GET_SINGLE_VISITOR_LOGS_REQUEST:
      return {
        ...state,
        getSingleVisitorLogsLoading: true,
      };
    case ACTIONS.GET_SINGLE_VISITOR_LOGS_RESPONSE:
      return {
        ...state,
        getSingleVisitorLogsLoading: false,
        getSingleVisitorLogsResponse: action.payload,
      };
    case ACTIONS.GET_SINGLE_VISITOR_LOGS_RESPONSE_CLEAR:
      return {
        ...state,
        getSingleVisitorLogsResponse: null,
      };
    //
    case ACTIONS.POST_MEDIA_UPLOAD_REQUEST:
      return {
        ...state,
        postMediaUploadLoading: true,
      };
    case ACTIONS.POST_MEDIA_UPLOAD_RESPONSE:
      return {
        ...state,
        postMediaUploadLoading: false,
        postMediaUploadResponse: action.payload,
      };
    case ACTIONS.POST_MEDIA_UPLOAD_RESPONSE_CLEAR:
      return {
        ...state,
        postMediaUploadResponse: null,
      };
    //
    case ACTIONS.POST_VISTOR_LOG_REQUEST:
    case ACTIONS.PUT_VISTOR_LOG_REQUEST:
    case ACTIONS.PUT_STATUS_VISTOR_LOG_REQUEST:
    case ACTIONS.PUT_CHECKOUT_VISTOR_LOG_REQUEST:
      return {
        ...state,
        postVisitorLogLoading: true,
      };
    case ACTIONS.POST_VISTOR_LOG_RESPONSE:
    case ACTIONS.PUT_VISTOR_LOG_RESPONSE:
    case ACTIONS.PUT_STATUS_VISTOR_LOG_RESPONSE:
    case ACTIONS.PUT_CHECKOUT_VISTOR_LOG_RESPONSE:
      return {
        ...state,
        postVisitorLogLoading: false,
        postVistorLogResponse: action.payload,
      };
    case ACTIONS.POST_VISTOR_LOG_RESPONSE_CLEAR:
      return {
        ...state,
        postVistorLogResponse: null,
      };
    //
    case ACTIONS.GET_VISITOR_LOGS_REQUEST:
      return {
        ...state,
        getVisitorLogsLoading: true,
      };
    case ACTIONS.GET_VISITOR_LOGS_RESPONSE:
      return {
        ...state,
        getVisitorLogsLoading: false,
        getVisitorLogsResponse: action.payload.data,
      };
    case ACTIONS.GET_VISITOR_LOGS_RESPONSE_CLEAR:
      return {
        ...state,
        getVisitorLogsResponse: null,
      };
    default:
      return state;
  }
};

export default VisitorLogReducer;
